export default __webpack_public_path__ + "static/media/ep_logo_wide.dbe56fd7.svg";